import Axios from "Services/Auth/AxiosInterceptors";

const get = async (path, params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "" && v !== false) qs.set(k, v);
  });
  const q = qs.toString();
  const {
    data: { result },
  } = await Axios.get(`/admin/emails/${path}${q ? `?${q}` : ""}`);
  return result;
};

const post = async (path, body = {}) => {
  const {
    data: { result },
  } = await Axios.post(`/admin/emails/${path}`, body);
  return result;
};

const del = async (path) => {
  const {
    data: { result },
  } = await Axios.delete(`/admin/emails/${path}`);
  return result;
};

export const GetEmailMarketingConfig = () => get("config");
export const GetAudienceCount = ({ windowDays } = {}) => get("audience", { windowDays });
export const GetCampaigns = () => get("campaign");
export const GetCampaign = (id) => get(`campaign/${id}`);
export const GetCampaignRecipients = (id, { page, perPage } = {}) =>
  get(`campaign/${id}/recipients`, { page: page > 1 ? page : undefined, perPage });
export const GetCampaignStats = (id) => get(`campaign/${id}/stats`);
export const CreateCampaign = (body) => post("campaign", body);
export const StartCampaign = (id) => post(`campaign/${id}/start`);
export const RunCampaignNow = (id) => post(`campaign/${id}/run-now`);
export const DeleteCampaign = (id) => del(`campaign/${id}`);
